import React from 'react';

interface LineRotateIconProps {
  size?: number;
  color?: string;
}

export const LineRotateIcon: React.FC<LineRotateIconProps> = ({ size = 12, color = '#686868' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 12 12" fill="none">
      <path
        d="M6.41421 3.82828L5 2.41406L6.41421 0.999849"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2.5C8.20914 2.5 10 4.29086 10 6.5C10 8.70914 8.20914 10.5 6 10.5C3.79086 10.5 2 8.70914 2 6.5C2 5.77143 2.19479 5.08835 2.53513 4.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
